import React, { useState, useCallback, useEffect } from 'react';
import { Chart, Series, Legend, ValueAxis,
  Aggregation, AggregationInterval, ArgumentAxis,
  Label, TickInterval, CommonSeriesSettings, Tooltip, } from 'devextreme-react/chart';
import { groupBy } from '../../utils/miscUtil';
import { TagBox } from 'devextreme-react/tag-box';
import { SelectBox } from 'devextreme-react/select-box';
import notify from 'devextreme/ui/notify';
import './Charts.scss';

const palette = ["rgba(20, 77, 109, 1)", "rgba(236, 80, 32, 1)", "rgba(92, 194, 215, 1)", "rgba(0, 162, 200, 1)", "rgba(20, 77, 109, 0.4)", "rgba(236, 80, 32, 0.4)", "rgba(92, 194, 215, 0.4)", "rgba(0, 162, 200, 0.4)"]

export default function ESGEmissions(props) {
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [selectedCompaniesList, setSelectedCompaniesList] = useState([]);
  const [selectedYear, setSelectedYear] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);

  useEffect(() => {
    setSelectedYear(parseInt(props.year)-1);
  }, [props.year]);

  useEffect(() => {
    var fd = [];
    var fd1 = [];
    var i = 0;

    fd1 = groupBy(props.data, 'company_name')
    setAllCompaniesList(Object.keys(fd1).sort())

    var originalData = props.data
    if (selectedCompaniesList.length) {
      originalData = originalData.filter((it) => selectedCompaniesList.includes(it['company_name']));
    }
    fd = originalData.filter((e) => {return ["46", "47", "48", "49", "50"].includes(e["Identifier"]) && e["year"] ===selectedYear.toString() && e["value"]});
    fd = groupBy(fd,"company_name");
    fd1 = {}
    fd = Object.keys(fd).map((key) => {
      if (fd[key].length >=5) {
        let r = {}
        r.name = key
        let total = 0
        for (i=0; i<fd[key].length; i++) {
          total = total + parseFloat(fd[key][i]['value'])
        }
        
        for (i=0; i<fd[key].length; i++) {
          try {
            r[fd[key][i]['Metrics'].split(":")[1].trim()] = parseFloat(fd[key][i]['value'])/total
            fd1[fd[key][i]['Metrics'].split(":")[1].trim()] = 1
          } catch (error) {
            notify("Incorrect metric name '"+fd[key][i]['Metrics']+"' for company '"+fd[key][i]['company_name']+"'. Metric name shoud include ':'", 'error', 5000);
            break
          }
        }
        return r
      }
    });
    /*fd = originalData.filter((e) => {return e["Identifier"] === "32" && e["year"] ===selectedYear.toString()});
    for (i=0; i<fd.length; i++){
      if (!fd[i]["value"]) {
        fd[i]["value"] = "NR"
      }
    }

    fd = Object.keys(fd).map((key) => ({name: key, val: fd[key].length}));*/
    setData(fd);

    setData2(Object.keys(fd1))

  }, [props.data, selectedYear, selectedCompaniesList]);

  const onCompaniesChanged = useCallback((e) => {
    setSelectedCompaniesList(e.value);
  }, [setSelectedCompaniesList])

  /*const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    txt = `<div><div class="tooltip-header">${pointInfo.argumentText}: ${pointInfo.valueText}</div></div>`
    return {
      html: txt,
    }
  }, []);*/

  const customizeTooltip = useCallback((pointInfo) => {
    var txt = ''
    if (pointInfo.total !== undefined) {
      txt = `<div><div class="tooltip-header">${pointInfo.argumentText}</div><div class="tooltip-body">`
      for (var i=0; i<pointInfo.points.length; i++) {
        txt = txt+`<div>${pointInfo.points[i].seriesName}: ${pointInfo.points[i].percentText}</div>`
      }
      txt=txt+`</div></div>`
    }
    return {
      html: txt,
    }
  }, []);

  function customizeText(arg) {
    let q = Math.floor((arg.value.getMonth() + 3) / 3).toString();
    let y = arg.value.getFullYear().toString();
    return `Qtr ${q} ${y}`;
  }

  const calculateCount = useCallback((aggregationInfo) => {
    if (!aggregationInfo.data.length) {
      return null;
    }
    var fd = groupBy(aggregationInfo.data, 'Time of Event')
    var fd1 = {"Not Specified":0, "(Morning) 6am-12pm":0, "(Afternoon) 12pm-6pm":0,  "(Evening) 6pm-12am":0, "(Overnight) 12am-6am":0}

    for (const [key, value] of Object.entries(fd)) {
      fd1[key] = value.length
    }
    fd1['total']=aggregationInfo.data.length;
    fd1['DATE OF EVENT (m/d/yyyy)'] = aggregationInfo.intervalStart;
    return fd1;
  }, []);

  const onYearChanged = useCallback((e) => {
    setSelectedYear(e.value);
  }, [setSelectedYear])

  return (
    <>
    <h4>Qualitative Metrics Strategies in {parseInt(props.year)-1} </h4>
    <div className="d-flex flex-row">
      <TagBox
          dataSource={allCompaniesList}
          value={selectedCompaniesList}
          showDropDownButton={true}
          width="100%"
          activeStateEnabled={true}
          multiline={false}
          showSelectionControls={true}
          onValueChanged={onCompaniesChanged}
          label={"Company"}
          labelMode="floating"
          placeholder={"Select Companies"}
      />
      <div className="mx-1"/>
      <SelectBox
          dataSource={[parseInt(props.year)-1, parseInt(props.year)-2, parseInt(props.year)-3]}
          value={selectedYear}
          width="250px"
          showDropDownButton={true}
          activeStateEnabled={true}
          onValueChanged={onYearChanged}
          label={"Year"}
          labelMode="floating"
          placeholder={"Year"}
      />
    </div>
    <hr className={'mb-4'}/>
    <div className="d-flex flex-column justify-content-between w-100">
      <Chart
        id="chart"
        dataSource={data}
        barGroupWidth={20}
        rotated={true}
        height={(allCompaniesList.length*30).toString()+"px"}
        palette={palette}
      >
        <CommonSeriesSettings
          argumentField="name"
        >
        </CommonSeriesSettings>

        {data2.map((e) => (<Series
          type="stackedbar"
          key={e}
          valueField={e}
          name={e}
          ignoreEmptyPoints={true}
        />))}

        <ValueAxis showZero={false} />
        <Legend visible={true} />
        <Tooltip
          enabled={true}
          shared={true}
          customizeTooltip={customizeTooltip}
        />
      </Chart>
    </div>
    </>
  );
}
